import request from '@/utils/request';

export async function audit(payload) {
  return request(`/iwms-wms/wms/wcs/picktask/audit?qty=${payload.qty}&qtyStr=${payload.qtyStr}&uuid=${payload.uuid}&version=${payload.version}`, {
    method: 'POST',
  });
}

export async function cancel(payload) {
  return request(`/iwms-wms/wms/wcs/picktask/cancel?uuid=${payload.uuid}&version=${payload.version}`, {
    method: 'POST',
  });
}

export async function page(payload) {
  return request(`/iwms-wms/wms/wcs/picktask/page`, {
    method: 'POST',
    body: payload,
  });
}

export async function resend(payload) {
  return request(`/iwms-wms/wms/wcs/picktask/resend?uuid=${payload.uuid}&version=${payload.version}`, {
    method: 'POST',
  });
}

export async function send(payload) {
  return request(`/iwms-wms/wms/wcs/picktask/send?dcUuid=${payload.dcUuid}`, {
    method: 'POST',
  });
}
